/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ExamExamitemidExamListQueryResponse,
  GetApiV1ExamExamitemidExamListPathParams,
  GetApiV1ExamExamitemidExamListQueryParams,
  GetApiV1ExamExamitemidExamList400,
  GetApiV1ExamExamitemidExamList401,
  GetApiV1ExamExamitemidExamList500,
} from "../../types/examQuestionLibraryController/GetApiV1ExamExamitemidExamList.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ExamExamitemidExamList } from "../../clients/examQuestionLibraryController/getApiV1ExamExamitemidExamList.ts";

export const getApiV1ExamExamitemidExamListQueryKey = (
  examItemId: GetApiV1ExamExamitemidExamListPathParams["examItemId"],
  params?: GetApiV1ExamExamitemidExamListQueryParams,
) =>
  [
    {
      url: "/api/v1/exam/:examItemId/exam-list",
      params: { examItemId: examItemId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1ExamExamitemidExamListQueryKey = ReturnType<
  typeof getApiV1ExamExamitemidExamListQueryKey
>;

export function getApiV1ExamExamitemidExamListQueryOptions(
  examItemId: GetApiV1ExamExamitemidExamListPathParams["examItemId"],
  params?: GetApiV1ExamExamitemidExamListQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ExamExamitemidExamListQueryKey(examItemId, params);
  return queryOptions<
    GetApiV1ExamExamitemidExamListQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamExamitemidExamList400
      | GetApiV1ExamExamitemidExamList401
      | GetApiV1ExamExamitemidExamList500
    >,
    GetApiV1ExamExamitemidExamListQueryResponse,
    typeof queryKey
  >({
    enabled: !!examItemId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ExamExamitemidExamList(examItemId, params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna a lista paginada de provas que contêm a questão informada (via OriginExamItemId). Aplica filtros de disciplina e empresa. Quando a empresa não é informada, retorna apenas provas globais (sem empresa associada). A empresa do usuário logado tem precedência sobre o filtro de empresa. **(Requer Authorization para autenticação)**
 * @summary Listar provas que contêm uma questão (Requer Authorization para autenticação)
 * {@link /api/v1/exam/:examItemId/exam-list}
 */
export function useGetApiV1ExamExamitemidExamList<
  TData = GetApiV1ExamExamitemidExamListQueryResponse,
  TQueryData = GetApiV1ExamExamitemidExamListQueryResponse,
  TQueryKey extends QueryKey = GetApiV1ExamExamitemidExamListQueryKey,
>(
  examItemId: GetApiV1ExamExamitemidExamListPathParams["examItemId"],
  params?: GetApiV1ExamExamitemidExamListQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ExamExamitemidExamListQueryResponse,
        ResponseErrorConfig<
          | GetApiV1ExamExamitemidExamList400
          | GetApiV1ExamExamitemidExamList401
          | GetApiV1ExamExamitemidExamList500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1ExamExamitemidExamListQueryKey(examItemId, params);

  const query = useQuery(
    {
      ...getApiV1ExamExamitemidExamListQueryOptions(examItemId, params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1ExamExamitemidExamList400
      | GetApiV1ExamExamitemidExamList401
      | GetApiV1ExamExamitemidExamList500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
